// extracted by mini-css-extract-plugin
module.exports = {"topicButton":"topicbutton_topicButton__3zEoI","viewed":"topicbutton_viewed__2cDae"};